module.exports = __webpack_public_path__ + "static/media/levelOn02.dcc37094.svg";